export enum ECustomerType {
  DIRECT = 1,
  DIS = 2,
}

export enum EPaymentCategory {
  DELIVERY_WITH_BILLING_BANK_TRANSFER = 1,
  DELIVERY_WITH_BILLING_CHEQUE = 2,
  COLLECTOR_WITH_BILLING_BANK_TRANSFER = 3,
  COLLECTOR_WITH_BILLING_CHEQUE = 4,
}
